import { useEffect } from "react";

export const useSEO = (title, description, og = null) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    if (og) {
      const setProp = (property, content) => {
        let m = document.querySelector(`meta[property="${property}"]`);
        if (!m) {
          m = document.createElement("meta");
          m.setAttribute("property", property);
          document.head.appendChild(m);
        }
        m.setAttribute("content", content);
      };
      setProp("og:title", og.title || title);
      setProp("og:description", og.description || description);
      setProp("og:type", "website");
      setProp("og:url", window.location.href);
      if (og.image) setProp("og:image", og.image);
    }
  }, [title, description]);
};
